import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import './DeleteButton.scss';

const DeleteButton = ({
  onInvoked,
}) => (
  <button
    type="button"
    className="table-delete-button"
    onClick={() => {
      if (onInvoked) {
        onInvoked();
      }
    }}
  >
    <FontAwesomeIcon color="#e74c3c" icon={solid('trash')} size="1x" />
  </button>
);

DeleteButton.propTypes = {
  onInvoked: PropTypes.func.isRequired,
};

export default DeleteButton;
